module.exports = __webpack_public_path__ + "img/logo@1.5x.d0456f49.svg";